import Home from 'components/Home/Home';
import CMSPage from 'components/CMSPage';
import About from 'components/About/About';
import Profile from 'components/Profile';
import Form from 'components/Form/Form';
import UserrequestList from 'components/Userrequest/UserrequestList';
import Userrequest from 'components/Userrequest/Userrequest';
import Login from 'components/Login/Login';
import CreateAccount from 'components/Account/CreateAccount';
import Account from 'components/Account/Account';
import Statistics from 'components/Statistics';
import Admin from 'components/Admin';
import Agenda from 'components/Agenda';
import Error404 from 'components/Error404';
import UsersManagement from 'components/Admin/UsersManagement';
import ActivitiesManagement from 'components/Admin/ActivitiesManagement';
import UploadFiles from 'components/Admin/UploadFiles';
import UpdateTemplates from 'components/Admin/UpdateTemplates';
import {
  REQUEST_CREATE,
  ACCOUNTS_CAN_MANAGE_USER,
  CAN_UPDATE_FEATURES,
  CAN_MANAGE_ACTIVITIES,
  CAN_UPDATE_TEMPLATE,
} from 'helpers/permissionsHelpers';

export const routes = [{
  path: '/',
  name: 'Home',
  component: Home,
  icon: 'home',
  exact: true,
  slug: 'homepage',
  protected: false,
  layout: {
    fullscreen: true,
  },
}, {
  path: '/about',
  name: 'About',
  component: About,
  icon: 'paper-clip',
  protected: false,
}, {
  path: '/create-account/:uidb64/:token/',
  name: 'Create an account',
  component: CreateAccount,
  icon: 'paper-clip',
  protected: false,
}, {
  path: '/account',
  name: 'Account',
  component: Account,
  icon: 'account',
  protected: true,
}, {
  path: '/profile',
  name: 'Profile',
  component: Profile,
  icon: 'paper-clip',
  protected: true,
}, {
  path: '/create-profile',
  name: 'Create a Profile',
  component: Profile,
  icon: 'paper-clip',
  protected: true,
}, {
  path: '/new-request',
  name: 'New request',
  component: Form,
  icon: 'form',
  protected: true,
  permissions: [REQUEST_CREATE],
  layout: {
    hideHeader: true,
    hideFooter: true,
  },
}, {
  path: '/manage-request',
  name: 'Manage requests',
  component: UserrequestList,
  icon: 'form',
  exact: true,
  protected: true,
}, {
  path: '/manage-request/detail/:id',
  name: 'Manage request detail',
  component: Userrequest,
  protected: true,
  layout: {
    hideHeader: true,
    hideFooter: true,
  },
}, {
  path: '/statistics',
  name: 'Statistics',
  component: Statistics,
  groups: ['staff'],
  protected: true,
  icon: 'line-chart',
}, {
  path: '/login',
  name: 'Login',
  component: Login,
  icon: 'form',
}, {
  path: '/administration',
  name: 'Admin',
  component: Admin,
  exact: true,
  permissions: [ACCOUNTS_CAN_MANAGE_USER],
  routes: [{
    path: '/users',
    name: 'Admin users',
    component: UsersManagement,
    permissions: [ACCOUNTS_CAN_MANAGE_USER],
  }, {
    path: '/upload-files',
    name: 'Upload Files',
    component: UploadFiles,
    permissions: [CAN_UPDATE_FEATURES],
    icon: 'form',
  }, {
    path: '/update-templates',
    name: 'Update templates',
    component: UpdateTemplates,
    permissions: [CAN_UPDATE_TEMPLATE],
    icon: 'file-text',
  }, {
    path: '/activities',
    name: 'Activities Management',
    component: ActivitiesManagement,
    permissions: [CAN_MANAGE_ACTIVITIES],
    icon: 'form',
  }],
}, {
  path: '/agenda',
  name: 'Agenda',
  groups: ['staff'],
  component: Agenda,
}, {
  path: '/pages/:pageSlug',
  name: 'Page CMS',
  component: CMSPage,
}, {
  name: 'Error404',
  component: Error404,
}];

export default routes;



// WEBPACK FOOTER //
// ./src/modules/routes.js